<template>
  <!-- Una b-card per la dash dei movimenti dove visualizzare i pulsanti -->
  <!-- di donwload specifici per i REFERENTI AZIENDALI.                  -->
  <!-- Ogni download viene eseguito in una modale separata al quale viene-->
  <!-- dedicato un suo proprio componente, in questo modo l'aggiunta di  -->
  <!-- nuovi tipi di download diventa modulare.                          -->
  <div>
    <!-- B-CARD CON LA LISTA DEI DOWNLOAD DISPONIBILI -->
    <!-- La rendiamo un ACCORDION per occupare meno spazio -->
    <b-card no-body class="mr-1 ml-1 mt-3">
        <b-link class="accordion-link" @click="open_donwload_accordion">
          <b-card-header v-b-tooltip.top title="Clicca per aprire/chiudere questa sezione">
            <h5>
              <font-awesome-icon icon="file-download" size="lg"/> Downloads
            </h5>
          </b-card-header>
        </b-link>
      <b-collapse id="download-accordion">
        <b-card-body>
          <!-- Download estrazione base Welfarebridge -->
          <b-row align-h="start">
            <b-col cols="8" md="4">
              <p class="text-justify">Download delle transazioni mensili per il cedolino paghe.</p>
              <p class="text-danger text-justify experimental-alert">
                <b><u>ATTENZIONE:</u> funzionalità sperimentale.</b> Ricordiamo che sarà comunque
                Welfarebit, fino a nuova comunicazione, ad inviare i <b>tracciati definitivi</b>
                con le transazioni da inserire a cedolino.
              </p>
            </b-col>
            <b-col cols="4" md="2">
              <b-button variant="primary" @click="show_wfbridge_modal=true">Apri</b-button>
            </b-col>
          </b-row>
          <!-- Download estrazione stato dei crediti residui per i singoli utenti -->
          <b-row class="border-top pt-4" align-h="start">
            <b-col cols="8" md="4">
              <p class="text-justify">Download dello stato dei crediti residui degli utenti.</p>
            </b-col>
            <b-col cols="4" md="2">
              <b-button variant="primary" @click="show_cred_res_users_modal=true">Apri</b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-collapse>
    </b-card>
    <!-- I DIVERSI DOWNLOAD DISPONIBILI -->
    <!-- Ognuno al suo interno gestisce una modale specifica per qual tipo di download -->
    <WfBridgeDownloadModal v-model="show_wfbridge_modal"/>
    <CredResUsersDownloadModal v-model="show_cred_res_users_modal"/>
  </div>
</template>

<script>
import WfBridgeDownloadModal from '@/components/dashmovimenti/refazidownloads/WfBridgeDownloadModal'
import CredResUsersDownloadModal from '@/components/dashmovimenti/refazidownloads/CredResUsersDownloadModal'

export default {
  name: 'RefAziDownloads',
  data () {
    return {
      // Flag per aprire la modale di download
      // del tracciato welfarebridge di fine mese
      show_wfbridge_modal : false,

      // Flag per aprire la modale di download
      // del tracciato per lo stato dei crediti
      // residui dei singoli utenti
      show_cred_res_users_modal : false
    }
  },
  methods : {
    /**
     * Apre e chiude l'accordion con dentro i vari download disponibili
     */
    open_donwload_accordion : function () {
      this.$root.$emit('bv::toggle::collapse', 'download-accordion')
    }
  },
  components : {
    WfBridgeDownloadModal,
    CredResUsersDownloadModal
  }
}
</script>

<style scoped>
.experimental-alert {
  font-size: smaller;
}
.accordion-link {
  text-decoration: none;
  color: black;
}
.accordion-link:hover {
  text-decoration: none;
  color: #6A6A6B;
}
</style>